export type MetaDataProperty = {
  activeFilters: number;
  key: string;
  label: string;
  sortByLabel: boolean;
  type: 'multi-and' | 'multi-or' | 'single';
  values: string[];
};

export function multiAndProperty(key: string, label: string, values: string[]): MetaDataProperty {
  return metaDataProperty({
    key,
    label,
    sortByLabel: false,
    type: 'multi-and',
    values,
  });
}

export function multiOrProperty(key: string, label: string, values: string[]): MetaDataProperty {
  return metaDataProperty({
    key,
    label,
    sortByLabel: false,
    type: 'multi-or',
    values,
  });
}

export function singleProperty(key: string, label: string, values: string[]): MetaDataProperty {
  return metaDataProperty({
    key,
    label,
    sortByLabel: false,
    type: 'single',
    values,
  });
}

/**
 * Create a new meta data property that can be passed to the @{MetaList}.
 *
 * @param key The key is the name of the property defined in meta data object.
 * @param label A translation key that is displayed to the user when it's appropriate.
 * @param sortByLabel Sort by label if true
 * @param type Type of the property (can influence the behaviour of components)
 * @param values A list of possible values. These should also be translation keys so the user can search using the current language.
 */
export function metaDataProperty({
  key,
  label,
  sortByLabel = false,
  type,
  values,
}: MetaDataPropertyOptions): MetaDataProperty {
  return {
    activeFilters: 0,
    key,
    label,
    sortByLabel,
    type: type,
    values,
  };
}

type MetaDataPropertyOptions = {
  key: string;
  label: string;
  sortByLabel?: boolean;
  type: 'multi-and' | 'multi-or' | 'single';
  values: string[];
};
